module.exports = __webpack_public_path__ + "static/media/night.a3f3f38d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/night.svg
// module id = 518
// module chunks = 0